

//
/* 
init :
setBuilderPanel :
preLoadImages :
createProductList : 
getResponsiveLayout : 

chainIscroll :
chainIscrollRefresh :
productIscroll :
productIscrollRefresh :
productVariantsIscroll :
productVariantsIscrollRefresh :
minibasketIscroll :
minibasketIscrollRefresh :

setVariantScrollHeight :

filterDataByTagArray :
getProductById :
getVariantById :

getMiniBasket :
drawProducts :
setView :
addToBasket :
addListeners : 
*/
//

(function($) {

    // Create Builder Prototype
    $.fn.builder = function(options) {

        // Establish our default settings
        var settings = $.extend({
            productList: '',
            basketList: '',
            panelHeight: ''
        }, options);

        // builder constructor
        function Builder(productList,basketList,panelHeight) {
            this.productList = productList;
            this.basketList = basketList;
            this.panelHeight = panelHeight;
        }

        Builder.prototype = {
            
            // INITIALISE BUILDER

            init : function(){

                // GET DATA FROM SHOPIFY API
                $.get( "/collections/builder-necklace-collection/products.json?limit=250", function(data) {
					productJson = data;

					// create list from data
					builder.createProductList();
					
                    // setup iScrolls
                    builder.chainIscroll();
                    builder.productIscroll();
                    builder.minibasketIscroll();
                    //builder.productVariantsIscroll();

                    // add JS event listeners
                    builder.addListeners();

                    // preload some images
                    builder.preLoadImages();

                    // Select default product type
                    $('#builder_type span[data-type=YW-builder-type-solid-gold]').click();
                    // set efault view
                    $('.view[data-view="view-landing"] .changeView').addClass('active');

                    // set default size of builder panel
                    builder.setBuilderPanel();

                    // console output
                    //console.log(builder);

				});

            },


            //***************************************
            // SET BUILDER PANEL DIMENSIONS
            //***************************************

            setBuilderPanel : function(){

                // Get Size of Chain image
                // Fit width of chain to be proportional this size
                var builderChainRatio = 4047 / 3959;
                var builderPanelWidth = $('.builder_panel').width();
                
                // on desktop, remove 100px
                // smaller sizes, set at 95% 
                if(builder.getResponsiveLayout() == 'desktop') {
                    var builderPanelHeight = $('.builder_panel').height() - 100;
                } else {
                    var builderPanelHeight = $('.builder_panel').height() * 0.95;
                }

                var builderPanelRatio = builderPanelWidth / builderPanelHeight;

                // set the width of the panel
                if(builderPanelRatio > builderChainRatio) {
                   
                    var newWidth = builderPanelHeight / builderChainRatio;

                    $('.builderChainProduct').css({
                        'width' : newWidth + 'px'
                    });

                } else {

                    $('.builderChainProduct').css({
                        'width' : '100%'
                    });
                }

            },


            //***************************************
            // PRE LOAD SOME IMAGES
            //***************************************

            preLoadImages : function(){

                // proload the chain images to make smoother experience
                var builderChainsArray = ['YW-builder-product-chain'];
                var builderChains = builder.filterDataByTagArray(builderChainsArray);

                // get Chains HTML
                $.each(builderChains, function(index) {
                    
                    var img = new Image();
                    img.src=builderChains[index]['images'][1].src;

                    var img = new Image();
                    img.src=builderChains[index]['images'][2].src;

                    var img = new Image();
                    img.src=builderChains[index]['images'][3].src;
                });


            },


            //***************************************
            // CREATE PRODUCT LIST DATA
            //***************************************

            createProductList : function(){
                // SET Product list from Json
                this.productList = productJson;

            },

            //***************************************
            // SET RESPONSIVE MODE, desktop, tablet etc
            //***************************************

            getResponsiveLayout : function(){

                var winWidth = $(window).width();

                if(winWidth >= 801) {
                    var responsiveMode = 'desktop';
                } else if(winWidth >= 641) {
                    var responsiveMode = 'tablet';
                } else if(winWidth >= 381) {
                    var responsiveMode = 'mobile';
                } else {
                    var responsiveMode = 'smallmobile';
                }
                return responsiveMode;

            },

            //***************************************
            // CREATE CHAIN ISCROLL
            //***************************************

            chainIscroll : function(){

                if ($('html').hasClass('touchevents')) {

                    var options = {
                        mouseWheel: true,
                        scrollbars: true,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: true,
                        listenY: true,
                        bounce: false,
                        click: true,
                        scrollX: true, 
                        scrollY: true
                    };

                } else {
                    var options = {
                        mouseWheel: true,
                        scrollbars: true,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: true,
                        listenY: true,
                        bounce: false,
                        scrollX: true, 
                        scrollY: true
                    };
                }

                chainScroll = new IScroll('#chain-scroller', options);

            },


            chainIscrollRefresh : function(){

                // decide between vertical and horizonal scroll
                // vertical for desktop
                // horizontal for mobile
                var mode = builder.getResponsiveLayout();
                if(mode!='desktop') {
                    
                    var chainCount = $('.chainSelectItem').length;
                    var chainWidth =  $('.chainSelectItem').width();
                    var chainContainerWidth = chainCount * chainWidth;
                    
                    if(chainContainerWidth < $(window).width()) {
                        chainContainerWidth = '100%';
                    } else {
                        chainContainerWidth = chainContainerWidth + 'px';
                    }

                    $('#chain-scroller-inner').css({
                        'width' : chainContainerWidth
                    });
                } else {
                    $('#chain-scroller-inner').css({
                        'width' : '100%'
                    });
                }

                chainScroll.refresh();

            },

            //***************************************
            // CREATE PRODUCT ISCROLL
            //***************************************

            productIscroll : function(){



                if ($('html').hasClass('touchevents')) {

                    var options = {
                        mouseWheel: true,
                        scrollbars: true,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: true,
                        listenY: true,
                        bounce: false,
                        click: true,
                        scrollX: true, 
                        scrollY: true
                    };

                } else {
                    var options = {
                        mouseWheel: true,
                        scrollbars: true,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: true,
                        listenY: true,
                        bounce: false,
                        scrollX: true, 
                        scrollY: true
                    };
                }

                productScroll = new IScroll('#product-scroller', options);

            },

            productIscrollRefresh : function(){

                var mode = builder.getResponsiveLayout();

                //console.log(mode);


                if(mode!='desktop') {
                    
                    //console.log('not desktop');

                    var productCount = $('#builder_products .data div.selected .productSelectItem').length;
                    var productWidth =  $('.productSelectItem').width();
                    var productContainerWidth = productCount * productWidth;
                    
                    //console.log(productCount);
                    //console.log(productWidth);

                    if(productContainerWidth < $(window).width()) {
                        productContainerWidth = '100%';
                    } else {
                        productContainerWidth = productContainerWidth + 'px';
                    }

                    $('#product-scroller-inner').css({
                        'width' : productContainerWidth
                    });
                } else {
                    $('#product-scroller-inner').css({
                        'width' : '100%'
                    });
                }

                productScroll.refresh();

            },


            //***************************************
            // CREATE PRODUCT VARIANT ISCROLL
            //***************************************

            productVariantsIscroll : function(){


                
                if (typeof productvariantsScroll !== 'undefined') {
                    productvariantsScroll.destroy();
                    productvariantsScroll = null;
                }

                if ($('html').hasClass('touchevents')) {

                    var options = {
                        mouseWheel: true,
                        scrollbars: false,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: false,
                        listenY: true,
                        bounce: false,
                        click: true,
                        scrollX: false, 
                        scrollY: true
                    };

                } else {
                    var options = {
                        mouseWheel: true,
                        scrollbars: false,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: false,
                        listenY: true,
                        bounce: false,
                        scrollX: false, 
                        scrollY: true
                    };
                }

                productvariantsScroll = new IScroll('#productvariants-scroller', options);

                productvariantsScroll.on('scrollStart', function(e){
                    $('#productvariants-scroller-inner span').removeClass('active');
                });

                

                productvariantsScroll.on('scroll', function(e){
                    

                    $('#currentProductVariantsDataSelectRing').css({
                        'top' : (this.y * -1) + 3 + 'px'
                    });

                    $('#currentProductVariantsDataTopGrad').css({
                        'top' : (this.y * -1) - 10 + 'px'
                    });

                    $('#currentProductVariantsDataBottomGrad').css({
                        'top' : ((this.y * -1) + builder.panelHeight) - 30 + 'px'
                    });

                    //this.y
                });

                $('#productvariants-scroller-inner span:eq(0)').addClass('active');
                var itemHeight = $('#currentProductVariantsData span:eq(0)').outerHeight();
                //console.log('currentpos');
                //console.log(itemHeight);

                var itemCount = $('#currentProductVariantsData span').length;
                //console.log('itemCount');
                //console.log(itemCount);

                productvariantsScroll.on('scrollEnd', function(e){
                    
                    $('#productvariants-scroller-inner span').removeClass('active');
                    //$('#productvariants-scroller-inner span:eq(' + this.currentPage.pageY + ')').addClass('active');

                    

                    var currentPos = -this.y + itemHeight;
                    //console.log('currentpos');
                    //console.log(currentPos);

                    var page = Math.round(currentPos / itemHeight);
                    //console.log('page');
                    //console.log(page);

                    if(page > itemCount) { page = itemCount; }

                    var newPos = ((page * itemHeight) - itemHeight) * -1;

                    this.scrollTo(0, newPos, 0);
                    $('#productvariants-scroller-inner span:eq(' + (page-1) + ')').addClass('active');
                    

                    if(page > 1) {
                        $("#currentProductVariantsData .prev").addClass('active');
                    } else {
                        $("#currentProductVariantsData .prev").removeClass('active');
                    }

                    $('#currentProductVariantsDataSelectRing').css({
                        'top' : (this.y * -1) + 3 + 'px'
                    });


                    $('#currentProductVariantsDataTopGrad').css({
                        'top' : (this.y * -1) - 10 + 'px'
                    });

                    $('#currentProductVariantsDataBottomGrad').css({
                        'top' : ((newPos * -1) + builder.panelHeight) - 30 + 'px'
                    });

                    // if(this.currentPage.pageY > 0) {
                    //     $("#currentProductVariantsData .prev").addClass('active');
                    // } else {
                    //     $("#currentProductVariantsData .prev").removeClass('active');
                    // }

                    // if ( this.options.snap && ( this.options.interactive || this.options.mouseWheel ) ) {
                    //     var snap = this._nearestSnap(this.x, this.y);
                    //     this.currentPage = snap;
                    // }

                    //console.log(productvariantsScroll);
                    // var itemHeight = $('#productvariants-scroller-inner span').outerHeight();
                    // var scrollHeight = $('#productvariants-scroller').outerHeight();

                    // var currentPos = this.y;
                    // var mod = (currentPos * -1) % itemHeight;

                    // //if(mod < itemHeight/2) {
                    // if(this.directionY < 0) {
                    //     var nearestItemPos = currentPos + mod;
                    // } else {
                    //     var nearestItemPos = currentPos - (itemHeight - mod);
                    // }


                    // if(mod!=0) {
                    //     this.scrollTo(0, nearestItemPos);
                    // }

                    // var itemSelected = ((nearestItemPos * -1) + itemHeight) / itemHeight;
                    // console.log(itemSelected);
                    //console.log(itemSelected);
                    

                });

                //productvariantsScroll.goToPage(1, 0, 1000);

                $("#currentProductVariantsData .next").unbind('click');
                $('#currentProductVariantsData .next').on('click', function(){
                    //productvariantsScroll.next();
                    var currentPos = productvariantsScroll.y;
                    var newPos = currentPos - itemHeight;

                    console.log(currentPos);
                    console.log(newPos);

                    productvariantsScroll.scrollTo(0, newPos, 100);
                });

                $("#currentProductVariantsData .prev").unbind('click');
                $('#currentProductVariantsData .prev').on('click', function(){
                    //productvariantsScroll.prev();
                    var currentPos = productvariantsScroll.y;
                    var newPos = currentPos + itemHeight;
                    productvariantsScroll.scrollTo(0, newPos, 100);
                });

            },

            
            productVariantsIscrollRefresh : function(){

                productvariantsScroll.refresh();

            },


            minibasketIscroll : function(){



                if ($('html').hasClass('touchevents')) {

                    var options = {
                        mouseWheel: true,
                        scrollbars: true,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: true,
                        listenY: true,
                        bounce: false,
                        click: true,
                        scrollX: true, 
                        scrollY: true
                    };

                } else {
                    var options = {
                        mouseWheel: true,
                        scrollbars: true,
                        mouseWheelSpeed: 10,
                        probeType: 3,
                        interactiveScrollbars: true,
                        listenX: true,
                        listenY: true,
                        bounce: false,
                        scrollX: true, 
                        scrollY: true
                    };
                }

                minibasketScroll = new IScroll('#builder_minibasket_scroller', options);

            },

            minibasketIscrollRefresh : function(){

                minibasketScroll.refresh();

            },


            //***************************************
            // PRE LOAD SOME IMAGES
            //***************************************

            setVariantScrollHeight : function(){
                var panelHeight;
                panelHeight = $('.view[data-view=view-product] .builderChainProductImage').height();
                if(panelHeight > 550) {
                    panelHeight = 550;
                }  


                //console.log('setVariantScrollHeight panelHeight');
                //console.log(panelHeight);

                $('#currentProductVariantsData').css({
                    'height' : (panelHeight - 200) + 'px' 
                });

                if (typeof productvariantsScroll === 'undefined') {
                    $('#currentProductVariantsDataBottomGrad').css({
                        'top' : (panelHeight - 200) - 30 + 'px'
                    });
                } else {
                    $('#currentProductVariantsDataBottomGrad').css({
                        'top' : ((productvariantsScroll.y * -1) + panelHeight -200) - 30 + 'px'
                    });
                }

                return (panelHeight - 200);

                

            },

            //***************************************
            // FILTER PRODUCT LIST DATA
            //***************************************


            filterDataByTagArray : function(valueList){
                
                // accepts array of data
                // checks tags for data

                if(valueList.length==1) {
                    var filteredData = $.grep(builder.productList['products'], function(v) {
                        //return v.tags === 'Test Product';
                        return $.inArray(valueList[0], v.tags )!=-1;
                    });
                } else if(valueList.length==2) {
                    var filteredData = $.grep(builder.productList['products'], function(v) {
                        //return v.tags === 'Test Product';
                        return $.inArray(valueList[0], v.tags )!=-1 && $.inArray(valueList[1], v.tags )!=-1;
                    });
                } else if(valueList.length==3) {
                    var filteredData = $.grep(builder.productList['products'], function(v) {
                        //return v.tags === 'Test Product';
                        return $.inArray(valueList[0], v.tags )!=-1 && $.inArray(valueList[1], v.tags )!=-1 && $.inArray(valueList[2], v.tags )!=-1;
                    });
                } else if(valueList.length==4) {
                    var filteredData = $.grep(builder.productList['products'], function(v) {
                        //return v.tags === 'Test Product';
                        return $.inArray(valueList[0], v.tags )!=-1 && $.inArray(valueList[1], v.tags )!=-1 && $.inArray(valueList[2], v.tags )!=-1  && $.inArray(valueList[3], v.tags )!=-1;
                    });
                }

                return(filteredData);
            	
            },




            //***************************************
            // GET PRODUCT BY ID
            //***************************************

            getProductById : function(productId){
                
                var productData = $.grep(builder.productList['products'], function(v) {
                    return v.id == productId;
                });
                return(productData);
            },


            //***************************************
            // GET PRODUCT BY ID
            //***************************************

            getVariantById : function(productId,variantId){
                
                var productData = $.grep(builder.productList['products'], function(v) {
                    return v.id == productId;
                });

                var variantData = $.grep(productData[0]['variants'], function(v) {
                    //return v.tags === 'Test Product';
                    return v.id == variantId;
                });

                return(variantData);
            },

            //***************************************
            // GET PRODUCT BY ID
            //***************************************

            getMiniBasket : function(){

                var price = 0;
                var miniBasketHTML = '';
                var basketCount = 0;

                $.each(builder.basketList, function(index) {

                    var product = builder.getProductById(builder.basketList[index][0]);
                    var item = builder.getVariantById(builder.basketList[index][0],builder.basketList[index][1]);
                    

                    // console.log(item[0].featured_image.src);
                    // console.log(product[0].title);
                    // console.log(item[0].title);
                    // console.log(item[0].price);

                    miniBasketHTML += '<div class="builder_minibasket_item">';
                    if(basketCount>0) {
                        miniBasketHTML += '<div class="builder_minibasket_item_remove removeitem" data-arraypos="' + basketCount + '"><span></span></div>';
                    } else {
                        miniBasketHTML += '<div class="builder_minibasket_item_remove"></div>';
                    }

                    basketCount++;
                    
                    miniBasketHTML += '<div class="builder_minibasket_item_image"><img src="' + item[0].featured_image.src + '" /></div>';
                    miniBasketHTML += '<div class="builder_minibasket_item_title">' + product[0].title + '<span>' + item[0].title + '</span></div>';
                    miniBasketHTML += '<div class="builder_minibasket_item_price">£' + item[0].price + '</div>';
                    miniBasketHTML += '</div>';
                    
                    price = price + parseInt(item[0].price);

                });

                $("#builder_minibasket_scroller_inner .data").html(miniBasketHTML);
                $(".currentPrice").html('£' + price);


                if(builder.basketList.length>12) {
                    $('.builderProductAdd').addClass('hidden');
                    $('#currentProductVariants').addClass('hidden');
                    $('#selectProductVariantType').addClass('hidden');
                    $('#maxReachedMsg').removeClass('hidden');
                } else {
                    $('.builderProductAdd').removeClass('hidden');
                    $('#currentProductVariants').removeClass('hidden');
                    $('#selectProductVariantType').removeClass('hidden');
                    $('#maxReachedMsg').addClass('hidden');
                }

                builder.minibasketIscrollRefresh();

                builder.addListeners();

            },


            //***************************************
            // GET PRODUCT BY ID
            //***************************************

            drawProducts : function(){

                var productCount = builder.basketList.length - 1;
                if(productCount % 2 == 0) {
                    var layout = 'even'; 
                    var startPosition = 6 - productCount/2 + 1;
                } else {
                    var layout = 'odd'; 
                    var startPosition = 5.5 - productCount/2 + 1;
                }

                // console.log(startPosition);

                // console.log(layout);

                $('.builderChainPoint').hide().html('');


                $.each(builder.basketList, function(index) {

                    if(index>0) {
                        var variant = builder.getVariantById(builder.basketList[index][0],builder.basketList[index][1]);
                        var item = builder.getProductById(builder.basketList[index][0]);
                        //console.log(item);
                        //console.log(variant);

                        var variantPosition = variant[0].position + 1;
                        //console.log(variantPosition);
                        var variantImage = item[0].images[variantPosition].src;
                        //console.log(variantImage);
                        $('.builderChainPoint[data-point=' + startPosition + '][data-style=' + layout + ']').html('<img src="' + variantImage + '" />')
                        startPosition++;
                    }   

                });

                setTimeout(function(){
                    $('.builderChainPoint').fadeIn(500, function(){
                        $('.builderProductAdd').html('Add').removeClass('disabled');
                    });
                }, 500)
                

            },

            //***************************************
            // SET VIEW
            //***************************************


            setView : function(view){
                console.log(view);
                $('.view').removeClass('active');
                $('.view[data-view=' + view +']').addClass('active');

                if(view=='view-landing') {
                    $('#builder_close').removeClass('active');
                } else {
                    $('#builder_close').addClass('active');
                }

                if(view!='view-landing' && view!='view-chain') {
                    $('.goback').addClass('active');
                } else {
                    $('.goback').removeClass('active');
                }

                builder.panelHeight = builder.setVariantScrollHeight();

            },

            //***************************************
            // ADD FULL AMMOUNT TO BASKET
            //***************************************


            addToBasket : function(){

                Shopify.queue = [];
                var quantity = 0;
                var builderProductId = 'id' + (new Date()).getTime();
                var itemList = '';


                $.each(builder.basketList, function(index) {

                    if(index>0) {
                        var variant = builder.getVariantById(builder.basketList[index][0],builder.basketList[index][1]);
                        var item = builder.getProductById(builder.basketList[index][0]);

                        console.log(variant);
                        console.log(item);
                        if(index>1) {
                            itemList += ',';
                        }
                        itemList += variant[0].title;
                    }

                });

                $.each(builder.basketList, function(index) {


                    Shopify.queue.push({
                        variantId: builder.basketList[index][1],
                        properties: {
                            '_necklaceId': builderProductId,
                            '_productType': 'builder_necklace',
                            '_itemList' : itemList
                        }
                    });
                    quantity++;

                });

                Shopify.queue.reverse();

                Shopify.moveAlong = function() {

                    // If we still have requests in the queue, let's process the next one.
                    if (Shopify.queue.length) {
                        var request = Shopify.queue.shift();
                        var data = 'id='+ request.variantId + '&quantity=1';

                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            dataType: 'json',
                            data: {
                                quantity:1,
                                id: request.variantId,
                                properties: request.properties
                            },
                            success: function(res){
                                Shopify.moveAlong();
                                quantity += 1;
                            },
                            error: function(){
                                console.log('an error ' + data);
                                // if it's not last one Move Along else update the cart number with the current quantity
                                if (Shopify.queue.length){
                                    Shopify.moveAlong()
                                } else {
                                    //$('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
                                }
                            }
                        });
                    }

                    // If the queue is empty, we add 1 to cart
                    else {
                        //builder.eraseCookie('otiumberg_builder');
                        location.href = '/cart';
                        

                        // $(document).on('cart.requestComplete', function(event, cart) {
                        //     basketScroll.refresh();
                        //     $('html').addClass('minicart-open');
                        //     $('#confirm_order').removeClass('processing').removeClass('disabled').html('Add to Basket');
                        // });
                        
                    }
                };

                Shopify.moveAlong();

                


            },

            //***************************************
            // SET PRODUCT JS LISTENERS
            //***************************************

            addListeners : function(){


                // Select Builder type
                // beads or solid gold
                $("#builder_type span").unbind('click');
                $('#builder_type span').on('click', function(){
                    
                    // toggle active state for sleected type
                    $('#builder_type span').removeClass('selected');
                    $(this).addClass('selected');

                    // get type from element attribute
                    var builderType = $(this).attr('data-type');

                    // get chains data for given type
                    var builderChainsArray = [builderType, 'YW-builder-product-chain'];
                    var builderChains = builder.filterDataByTagArray(builderChainsArray);
                    //console.log('Available Chains');
                    //console.log(builderChains);

                    // console.log(builderChains[0]['id']);
                    // console.log(builderChains[0]['images'][2]['src']);
                    
                    // get Chains HTML
                    var chainsHTML = '';
                    $.each(builderChains, function(index) {
                        chainsHTML += '<div class="chainSelectItem" data-id="' + builderChains[index]['id'] + '">';
                        chainsHTML += '<div class="chainSelectItemImage">';
                        chainsHTML += '<img src="' + builderChains[index]['images'][2].src + '" />';
                        chainsHTML += '</div>';
                        chainsHTML += '<div class="chainSelectItemTitle">';
                        chainsHTML += builderChains[index]['title'];
                        chainsHTML += '</div>';
                        chainsHTML += '<div class="chainSelectItemPrice">£';
                        chainsHTML += builderChains[index]['variants'][0]['price'];
                        chainsHTML += '</div>';
                        chainsHTML += '</div>';
                    });

                    // output chain HTML
                    $('#builder_chains .data').html(chainsHTML);

                    $('#builder_fonts div').removeClass('active');
                    $('#builder_fonts div[data-type=' + builderType + ']').addClass('active');

                    builder.addListeners();

                    $("#builder_chains div.chainSelectItem:eq(0)").click();

                    builder.chainIscrollRefresh();

                });

                
                $("#builder_chains .chainSelectItem").unbind('click');
                $('#builder_chains .chainSelectItem').on('click', function(){
                    
                    $('#builder_chains .chainSelectItem').removeClass('selected');
                    $(this).addClass('selected');

                    $('.builderChainProductImageAltToggle').fadeOut(500);
                    

                    var productId = $(this).attr('data-id');
                    var product = builder.getProductById(productId);
                    // console.log('Chain Selected');
                    // console.log(product);

                    $("#currentChainSelected span").html(product[0].title);

                    var productVariants = product[0].variants;
                    //console.log(productVariants);

                    var variantsHTML = '';
                    $.each(productVariants, function(index) {
                        variantsHTML += '<span data-id="' + productId + '" data-variant-id="' + productVariants[index]['id'] + '">' + productVariants[index]['title'].replace(" inch", "\"") + '</span>';
                    });
                    $('#currentChainVariants .data').html(variantsHTML);

                    $('.builderChainProduct .builderChainProductImage').fadeOut(500, function(){
                        $('.builderChainProduct .builderChainProductImage').html('<img src="' + product[0].images[3].src + '" />')
                    });
                    
                    $('.builderChainAltView').css({
                        'background-image' : 'url(' + product[0].images[1].src + ')'
                    });

                    setTimeout(function(){
                        $('.builderChainProduct .builderChainProductImage').fadeIn(500);
                        $('.builderChainProductImageAltToggle').fadeIn(500);
                    }, 500);

                    builder.addListeners();

                    $("#currentChainVariants span:eq(0)").click();
                    
                });


                $(".builderChainProductImageAltToggle").unbind('click');
                $('.builderChainProductImageAltToggle').on('click', function(){
                    
                    $('.builderChainAltView').fadeIn(500);
                    $('#builder_close').removeClass('active');

                });

                $(".builderChainAltViewClose").unbind('click');
                $('.builderChainAltViewClose').on('click', function(){
                    
                    $('.builderChainAltView').fadeOut(500);
                    $('#builder_close').addClass('active');

                });

                $("#currentChainVariants span").unbind('click');
                $('#currentChainVariants span').on('click', function(){
                    $('#currentChainVariants span').removeClass('selected');
                    $(this).addClass('selected');

                    var productId = $(this).attr('data-id');
                    var variantId = $(this).attr('data-variant-id');
                    var variant = builder.getVariantById(productId,variantId);

                    //console.log('Chain Variant Selected');
                    //console.log(variant);

                    $("#currentChainVariantSelected span").html(variant[0].title);
                    $("#view-chain-container .currentPrice").html('£' + variant[0].price)

                });


                $("#builder_fonts > div").unbind('click');
                $('#builder_fonts > div').on('click', function(){

                    if($(this).hasClass('fontSelectItemDisabled')) {
                        return false;
                    }

                    var builderType = $(this).attr('data-type');
                    var builderFont = $(this).attr('data-font');
                    var builderFontLabel = $(this).attr('data-font-label');


                    builder.basketList.splice(1,builder.basketList.length - 1);
                    builder.getMiniBasket();
                    builder.drawProducts();
                    //console.log(builder.basketList);

                    $('#builder_fonts div').removeClass('selected');
                    $(this).addClass('selected');

                    var builderLettersArray = [builderType, builderFont, 'YW-builder-product-letter'];
                    var builderLetters = builder.filterDataByTagArray(builderLettersArray);

                    var builderNumbersArray = [builderType, builderFont, 'YW-builder-product-number'];
                    var builderNumbers = builder.filterDataByTagArray(builderNumbersArray);

                    var builderCharmsArray = [builderType, 'YW-builder-product-charm'];
                    var builderCharms = builder.filterDataByTagArray(builderCharmsArray);


                    var lettersHTML = '';
                    $.each(builderLetters, function(index) {
                        lettersHTML += '<div class="productSelectItem" data-id="' + builderLetters[index]['id'] + '">';
                        lettersHTML += '<div class="productSelectItemImage">';
                        lettersHTML += '<img src="' + builderLetters[index]['images'][1].src + '" />';
                        lettersHTML += '</div>';
                        lettersHTML += '<div class="productSelectItemTitle">';
                        lettersHTML += builderLetters[index]['title'];
                        lettersHTML += '</div>';
                        lettersHTML += '<div class="productSelectItemPrice">£';
                        lettersHTML += builderLetters[index]['variants'][0]['price'];
                        lettersHTML += '</div>';
                        lettersHTML += '</div>';
                    });
                    $('#builder_products .data .letters').html(lettersHTML);


                    var numbersHTML = '';
                    $.each(builderNumbers, function(index) {
                        numbersHTML += '<div class="productSelectItem" data-id="' + builderNumbers[index]['id'] + '">';
                        numbersHTML += '<div class="productSelectItemImage">';
                        numbersHTML += '<img src="' + builderNumbers[index]['images'][1].src + '" />';
                        numbersHTML += '</div>';
                        numbersHTML += '<div class="productSelectItemTitle">';
                        numbersHTML += builderNumbers[index]['title'];
                        numbersHTML += '</div>';
                        numbersHTML += '<div class="productSelectItemPrice">£';
                        numbersHTML += builderNumbers[index]['variants'][0]['price'];
                        numbersHTML += '</div>';
                        numbersHTML += '</div>';
                    });
                    $('#builder_products .data .numbers').html(numbersHTML);

                    var charmsHTML = '';
                    $.each(builderCharms, function(index) {
                        charmsHTML += '<div class="productSelectItem" data-id="' + builderCharms[index]['id'] + '">';
                        charmsHTML += '<div class="productSelectItemImage">';
                        charmsHTML += '<img src="' + builderCharms[index]['images'][1].src + '" />';
                        charmsHTML += '</div>';
                        charmsHTML += '<div class="productSelectItemTitle">';
                        charmsHTML += builderCharms[index]['title'];
                        charmsHTML += '</div>';
                        charmsHTML += '<div class="productSelectItemPrice">£';
                        charmsHTML += builderCharms[index]['variants'][0]['price'];
                        charmsHTML += '</div>';
                        charmsHTML += '</div>';
                    });
                    $('#builder_products .data .charms').html(charmsHTML);
                    
                    builder.addListeners();

                    $("#selectProductVariantType span:eq(0)").click();
                    //$("#builder_products .data .letters .productSelectItem:eq(0)").click();
                    builder.productIscrollRefresh();
                    
                    $('#builderFontLabel').html(builderFontLabel);

                    builder.setView('view-product');


                });

                $("#selectProductVariantType span").unbind('click');
                $('#selectProductVariantType span').on('click', function(){

                    $('#selectProductVariantType span').removeClass('selected');
                    $(this).addClass('selected');

                    var variantType = $(this).attr('data-variantType');

                    $('#builder_products .data div').removeClass('selected')
                    $('#builder_products .data div.' + variantType).addClass('selected')
                    $("#builder_products .data div." + variantType + " .productSelectItem:eq(0)").click();

                    builder.productIscrollRefresh();

                })

                $("#builder_products div.productSelectItem").unbind('click');
                $('#builder_products div.productSelectItem').on('click', function(){
                    
                    $('#builder_products div.productSelectItem').removeClass('selected');
                    $(this).addClass('selected');

                    var productId = $(this).attr('data-id');
                    var product = builder.getProductById(productId);
                    //console.log(product);

                    $("#currentProductSelected span").html(product[0].title);

                    var productVariants = product[0].variants;
                    //console.log(productVariants);

                    var variantsHTML = '';
                    $.each(productVariants, function(index) {

                        if(productVariants[index].hasOwnProperty('featured_image')) {

                            //console.log('this');
                            //console.log(productVariants[index]);

                            variantsHTML += '<span data-id="' + productId + '" data-variant-id="' + productVariants[index]['id'] + '">';
                            variantsHTML += '<img src="' + productVariants[index]['featured_image'].src + '" />';
                            variantsHTML += '</span>';

                        } else {
                            //console.log(productVariants[index]);
                        }
                    });
                    variantsHTML += '<div id="currentProductVariantsDataSelectRing"></div><div id="currentProductVariantsDataTopGrad"></div><div id="currentProductVariantsDataBottomGrad"></div>';
                    $('#currentProductVariants #productvariants-scroller-inner').html(variantsHTML);

                    builder.addListeners();

                    //builder.productVariantsIscrollRefresh();
                    builder.productVariantsIscroll();

                    $('#currentProductVariantsDataBottomGrad').css({
                        'top' : (builder.panelHeight) - 30 + 'px'
                    });
                    
                });


                $("#view_toggle span").unbind('click');
                $('#view_toggle span').on('click', function(){
                    
                    $('#view_toggle span').removeClass('selected');
                    $(this).addClass('selected');

                    var view = $(this).attr('data-view');
                    builder.setView(view);
                });


                $(".changeView").unbind('click');
                $('.changeView').on('click', function(){

                    var view = $(this).attr('data-view');
                    builder.setView(view);
                    chainScroll.refresh();

                });

                $(".ctrlnext").unbind('click');
                $('.ctrlnext').on('click', function(){

                    var view = $(this).attr('data-view');
                    
                    // ADD CHAIN
                    if(view=='view-font') {
                        var chainId = $('#currentChainVariants .data span.selected').attr('data-id');
                        var chainVariantId = $('#currentChainVariants .data span.selected').attr('data-variant-id');

                        //console.log(chainId);
                        //console.log(chainVariantId);

                        builder.basketList = [
                          [chainId, chainVariantId]
                        ];
                    } 


                    builder.setView(view);
                    chainScroll.refresh();

                    builder.getMiniBasket();

                });

                $(".builderProductAdd").unbind('click');
                $('.builderProductAdd').on('click', function(){

                    if(!$(this).hasClass('disabled')) {

                        $('.builderProductAdd').html('adding').addClass('disabled');
                        //var selectedProduct = productvariantsScroll.currentPage.pageY;
                        //var productId = $('#productvariants-scroller-inner span:eq(' + selectedProduct + ')').attr('data-id');
                        //var productVariantId = $('#productvariants-scroller-inner span:eq(' + selectedProduct + ')').attr('data-variant-id');

                        var productId = $('#productvariants-scroller-inner span.active').attr('data-id');
                        var productVariantId = $('#productvariants-scroller-inner span.active').attr('data-variant-id');

                        builder.basketList.push([productId, productVariantId]);
                        builder.getMiniBasket();
                        builder.drawProducts();

                    }
                });

                $(".viewMiniCart, .ctrlFinish").unbind('click');
                $(".viewMiniCart, .ctrlFinish").on('click', function(){
                    //return false;
                    $('#builder_minibasket').addClass('active');
                    $('.view').addClass('obscure');

                });

                $("#builder_minibasket_close").unbind('click');
                $("#builder_minibasket_close").on('click', function(){
                    //return false;
                    $('#builder_minibasket').removeClass('active');
                    $('.view').removeClass('obscure');
                });

                $(".removeitem").unbind('click');
                $(".removeitem").on('click', function(){
                    //return false;
                    var arrayPos = $(this).attr('data-arraypos');

                    builder.basketList.splice(arrayPos,1);
                    builder.getMiniBasket();
                    builder.drawProducts();

                });

                $(".buynow").unbind('click');
                $('.buynow').on('click', function(){
                    //return false;
                    if(!$(this).hasClass('disabled')) {
                       $(this).addClass('disabled');
                       $(this).html('Please Wait..');
                       builder.addToBasket();
                    }
                    
                });

                $(window).resize(function(){
                    builder.setBuilderPanel();
                    builder.chainIscrollRefresh();
                    builder.panelHeight = builder.setVariantScrollHeight();
                });


            }


            

        };

        // end builder prototype






        // create new instance of builder class

        var builder = new Builder(
            settings.productList
        );

        // call set slider initialise method
        builder.init();

   
    }

}($));


$(window).on('load', function(){
console.log("it is working");
	$('#builderPage').builder({
       productList: '',
       basketList: '',
       panelHeight: ''
	});

});

